// apps/roleforge-app/src/components/forge/forge-burst-timeline.ts
//
// Plan 3e-ii — Task 6.3: Typed timeline data for the Forge synthesis burst.
//
// The synthesis burst is an animated overlay shown for ~10 seconds in the
// Forge fork while the agent fires its synthesis tool calls in rapid
// succession after Q6. Each phase has a trigger event from the
// `operating_model` SSE surface and a narration cue spoken in lockstep on
// the right-side AgentActivityPanel.
//
// Note: the actual operating-model event for completion is
// `synthesis.matrix.assembled` (see OperatingModelEventPayload in
// converse-types.ts). The plan refers to it as `synthesis.assembled`; we
// use the real event name for type alignment.

export type ForgeBurstPhase =
  | 'engines'
  | 'journey'
  | 'roles'
  | 'opportunities'
  | 'roi'
  | 'done';

export interface ForgeBurstPhaseSpec {
  phase: ForgeBurstPhase;
  triggerEvent: string;
  narrationCue: string;
  minDurationMs: number;
}

export const FORGE_BURST_TIMELINE: readonly ForgeBurstPhaseSpec[] = [
  {
    phase: 'engines',
    triggerEvent: 'engine.created',
    narrationCue:
      'Drafting your AI Workforce Blueprint… proposing engines based on your offer type…',
    minDurationMs: 1500,
  },
  {
    phase: 'journey',
    triggerEvent: 'engine.step.added',
    narrationCue: 'Mapping the customer journey…',
    minDurationMs: 1500,
  },
  {
    phase: 'roles',
    triggerEvent: 'opportunity.role.assigned',
    narrationCue: 'Recommending three roles to start…',
    minDurationMs: 1500,
  },
  {
    phase: 'opportunities',
    triggerEvent: 'opportunity.surfaced',
    narrationCue: 'Surfacing opportunities for the team to tackle first…',
    minDurationMs: 2000,
  },
  {
    phase: 'roi',
    triggerEvent: 'opportunity.scored',
    narrationCue:
      "Computing rough ROI estimates from market benchmarks since you don't have actual numbers yet…",
    minDurationMs: 2000,
  },
  {
    phase: 'done',
    triggerEvent: 'synthesis.matrix.assembled',
    narrationCue:
      'Done — drop into Validation mode and sculpt anything you want to change.',
    minDurationMs: 0,
  },
] as const;
